import {Component, Input} from '@angular/core';
import {MachineCopySettings} from '@models/machine/machine-copy-settings';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';

import {Machine} from '@models/machine/machine';

@Component({
    selector: 'scitis-admin-machine-cloning-info',
    templateUrl: './machine-cloning-info.component.html',
    styleUrls: ['./machine-cloning-info.component.scss'],
    standalone: false
})
export class MachineCloningInfoComponent {

  @Input()
  machine: Machine = new Machine();

  @Input()
  sourceMachineName: string = '';

  @Input()
  copySetting: MachineCopySettings = new MachineCopySettings();

  @Input()
  usedTables: String[] = new Array<String>();

  constructor(
      private activeModal: NgbActiveModal
  ) {
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onOk(): void {
    this.activeModal.close('confirmed');
  }

}
